import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { LayoutsModule } from 'src/app/layouts/layouts.module'
import { AppPreloader } from 'src/app/app-routing-loader'
import { AuthGuard } from 'src/app/@vb/components/Guard/auth.guard'

// layouts & notfound
import { LayoutAuthComponent } from 'src/app/layouts/Auth/auth.component'
import { LayoutMainComponent } from 'src/app/layouts/Main/main.component'

// VB:REPLACE-START:ROUTER-IMPORTS
// All component imports removed - now using lazy loading
// VB:REPLACE-END:ROUTER-IMPORTS

const routes: Routes = [
  {
    path: '',
    // VB:REPLACE-NEXT-LINE:ROUTER-REDIRECT
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    component: LayoutMainComponent,
    canActivate: [AuthGuard],
    children: [
      // VB:REPLACE-START:ROUTER-CONFIG
      {
        path: 'user-profile',
        data: { title: 'User Profile' },
        loadChildren: () =>
          import('./pages/user-profile/user-profile.module').then((m) => m.UserProfileModule),
      },
      {
        path: 'dashboard',
        data: { title: 'Dashboard' },
        loadChildren: () =>
          import('./pages/dashboard/dashboard.module').then((m) => m.DashboardModule),
      },
      {
        path: 'table',
        data: { title: 'Table' },
        loadChildren: () => import('./pages/table/table.module').then((m) => m.TableModule),
      },
      {
        path: 'ticketing',
        data: { title: 'Ticketing' },
        loadChildren: () =>
          import('./pages/ticketing/ticketing.module').then((m) => m.TicketingModule),
      },
      {
        path: 'administration',
        data: { title: 'Administration' },
        loadChildren: () =>
          import('./pages/administration/administration.module').then(
            (m) => m.AdministrationModule,
          ),
      },
      {
        path: 'human-resource',
        data: { title: 'Human Resource' },
        loadChildren: () => import('./pages/hr/hr.module').then((m) => m.HumanResourceModule),
      },
      {
        path: 'onfleet',
        data: { title: 'On Fleet Management' },
        loadChildren: () => import('./pages/onfleet/onfleet.module').then((m) => m.OnfleetModule),
      },
      {
        path: 'cms',
        data: { title: 'CMS' },
        loadChildren: () => import('./pages/cms/cms.module').then((m) => m.CmsModule),
      },
      {
        path: 'leave-management',
        data: { title: 'Leave Management' },
        loadChildren: () =>
          import('./pages/leave-management/leave-management.module').then(
            (m) => m.LeaveManagementModule,
          ),
      },
      {
        path: 'approval',
        loadChildren: () =>
          import('./pages/branding-approval/branding-approval.module').then(
            (m) => m.BrandingApprovalModule,
          ),
      },
      {
        path: 'freelance-management',
        data: { title: 'Freelance Management' },
        loadChildren: () =>
          import('./pages/freelance-agent/freelance-management.module').then(
            (m) => m.FreelanceManagementModule,
          ),
      },
      {
        path: 'mitra-management',
        data: { title: 'On Mitra Management' },
        loadChildren: () =>
          import('./pages/on-mitra-management/mitra-management.module').then(
            (m) => m.MitraManagementModule,
          ),
      },
      {
        path: 'onapps-management',
        data: { title: 'OnApps Management' },
        loadChildren: () =>
          import('./pages/onapps-management/onapps-management.module').then(
            (m) => m.OnappsManagementModule,
          ),
      },
      {
        path: 'cta',
        data: { title: 'CTA' },
        loadChildren: () => import('./pages/cta/cta.module').then((m) => m.CtaModule),
      },
      {
        path: 'asset-management',
        data: { title: 'Asset Management' },
        loadChildren: () =>
          import('./pages/asset-management/asset-management.module').then(
            (m) => m.AssetManagementModule,
          ),
      },
      {
        path: 'sales',
        data: { title: 'Sales' },
        loadChildren: () => import('./pages/sales/sales.module').then((m) => m.SalesModule),
      },
      {
        path: 'permit-management',
        data: { title: 'Permit Management' },
        loadChildren: () =>
          import('./pages/permit-management/permit-management.module').then(
            (m) => m.PermitManagementModule,
          ),
      },
    ],
  },
  {
    path: 'auth',
    component: LayoutAuthComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('src/app/pages/auth/auth.module').then((m) => m.AuthModule),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/auth/404',
  },
]

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      preloadingStrategy: AppPreloader,
    }),
    LayoutsModule,
  ],
  declarations: [
    // VB:REPLACE-START:ROUTER-DECLARATIONS
    // All component declarations removed - now using lazy loading
    // VB:REPLACE-END:ROUTER-DECLARATIONS
  ],
  providers: [AppPreloader],
  exports: [RouterModule],
})
export class AppRoutingModule {}
